<template>
  <path d="M6 15L7 10L3 8.5L10 1L9 6L13 7.5L6 15Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</template>